<div
  class="alert mat-typography"
  [ngClass]="{
    'alert-info': alertType === 'info',
    'alert-success': alertType === 'success',
    'alert-warning': alertType === 'warning',
    'alert-error': alertType === 'error'
  }"
  role="alert"
  >
  <table>
    <tr>
      <td>
        @if (alertType === 'info') {
          <mat-icon>info_outline</mat-icon>
        }
        @if (alertType === 'success') {
          <mat-icon>check_circle_outline</mat-icon>
        }
        @if (alertType === 'warning') {
          <mat-icon>warning_amber_outline</mat-icon>
        }
        @if (alertType === 'error') {
          <mat-icon>error_outline</mat-icon>
        }
      </td>
      <td [innerHTML]="message | translate"></td>
      <td>@if (additionalIcon) {
        <mat-icon>{{ additionalIcon }}</mat-icon>
      }</td>
    </tr>
  </table>
</div>
